import _ from "lodash";

export const replaceArrayElement = <T>(
  array: T[],
  index: number,
  value: T
): T[] => {
  const newArray = _.cloneDeep(array);
  newArray[index] = value;
  return newArray;
};

export const isEmpty = (value: Array<any>) => _.isEmpty(value);
